import React, { Component } from 'react';

import Popover from 'material-ui/Popover';
import Paper from 'material-ui/Paper';

import theme from '../../../muiTheme';

class LongString extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { text } = this.props;

    /* eslint-disable */
    return (
      <div style={styles.container}>
        <a style={styles.text} onClick={this.handleClick}>
          {text}
        </a>
        <Popover
          style={styles.popover}
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          onRequestClose={this.handleRequestClose}
        >
          <Paper zDepth={1}>{text}</Paper>
        </Popover>
      </div>
    );
    /* eslint-enable */
  }
}

export default LongString;

const styles = {
  container: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  text: {
    whiteSpace: 'nowrap',
    color: theme.palette.textColor,
    cursor: 'pointer'
  },
  popover: {
    maxWidth: '300px',
    padding: '1em'
  }
};



// WEBPACK FOOTER //
// ./src/components/common/LongString/LongString.js